export default "__VITE_ASSET__CA9Kra$e__"